import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "components/Icon";
import NavSubList from "components/NavSubList";
import {
  entries,
  general,
  mealBookings,
  mealMenus,
  mealPlans,
  settings,
  transactions,
} from "nav";
import React from "react";
import { Link as RouterLink, useLocation } from "react-router";

export default function Nav(props) {
  const { handleDrawerClose, open } = props;

  let location = useLocation();

  return (
    <div>
      <List>
        {general.map((item) => (
          <div key={item.name}>
            <ListItemButton
              component={RouterLink}
              to={item.url}
              selected={location.pathname === item.url}
              onClick={handleDrawerClose}
              sx={{
                justifyContent: open ? "initial" : "center",
                height: 48,
              }}
            >
              <ListItemIcon
                sx={{
                  mr: 0,
                  justifyContent: open ? "initial" : "center",
                }}
              >
                <Icon icon={item.icon} />
              </ListItemIcon>
              {open && <ListItemText primary={item.name} />}
            </ListItemButton>
          </div>
        ))}
        <NavSubList
          handleDrawerClose={handleDrawerClose}
          title="Meal Plans"
          items={mealPlans}
          menuOpen={open}
        />
        <NavSubList
          handleDrawerClose={handleDrawerClose}
          title="Transactions"
          items={transactions}
          menuOpen={open}
        />
        <NavSubList
          handleDrawerClose={handleDrawerClose}
          title="Meal Entries"
          items={entries}
          menuOpen={open}
        />
        <NavSubList
          handleDrawerClose={handleDrawerClose}
          title="Meal Bookings"
          items={mealBookings}
          menuOpen={open}
        />
        <NavSubList
          handleDrawerClose={handleDrawerClose}
          title="Meal Menus"
          items={mealMenus}
          menuOpen={open}
        />
        <NavSubList
          handleDrawerClose={handleDrawerClose}
          title="Settings"
          items={settings}
          menuOpen={open}
        />
      </List>
      <Divider />
      <List sx={{ pb: 8 }}>
        <ListItemButton
          component={Link}
          href={"https://status.payandconnect.co.za/"}
          target="_blank"
          sx={{
            justifyContent: open ? "initial" : "center",
            height: 48,
          }}
        >
          <ListItemIcon
            sx={{
              mr: 0,
              justifyContent: open ? "initial" : "center",
            }}
          >
            <ArrowCircleUpIcon />
          </ListItemIcon>
          {open && (
            <>
              <ListItemText primary="System Status" />
              <ListItemIcon
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <OpenInNewIcon />
              </ListItemIcon>
            </>
          )}
        </ListItemButton>
      </List>
    </div>
  );
}
